import { fetchBrary } from '../utils/FetchBrary';
import { addNotificationToApp } from './NotificationsActions';
import CrudActionService from "../utils/ReduxCrudBuilder/CrudActionService";
import { Base64ToArrayBuffer, Base64ToJavaScriptBlob, SaveByteArray } from '../utils/BlobStuff';
import * as DocumentApi from '../apiCalls/documents/documentApiCalls';

const DocumentsActionService = new CrudActionService("Document", "Documents");

const ROOT_URL = process.env.REACT_APP_API_URL;

export async function fetchGetDocumentsForGroup(groupId, groupPlanDesignId) {
    const json = await fetchBrary.get(`${ROOT_URL}/api/group/${groupId}/documents/${groupPlanDesignId}`);
    return json;
}

/****************************************************************
 * DOWNLOAD RAW DOCUMENT BYTES AS A FILE
 ****************************************************************/

//
export function fetchGetDocumentBlobForEmployee(packageId, documentId) {
    return async (dispatch) => {
        dispatch(DocumentsActionService.requestDocument());
        try {
            const json = await DocumentApi.getPackageDocument(packageId, documentId);
            dispatch(DocumentsActionService.requestDocumentSuccess(json));
            const stream = Base64ToArrayBuffer(json.blob);
            const fileName = json.name;
            SaveByteArray(fileName, stream);
        }
        catch (err) {
            dispatch(DocumentsActionService.requestDocumentFailure(err));
            dispatch(addNotificationToApp("Document Failed to Fetch ", "danger"));
        }
    };
}

export function fetchGetDocumentBlobForEmployeeAsBlob(packageId, documentId) {
    return async (dispatch) => {
        dispatch(DocumentsActionService.requestDocument());
        try {
            const json = await DocumentApi.getPackageDocument(packageId, documentId);
            dispatch(DocumentsActionService.requestDocumentSuccess(json));
            const blob = Base64ToJavaScriptBlob(json.blob);
            return blob;
        }
        catch (err) {
            dispatch(DocumentsActionService.requestDocumentFailure(err));
            dispatch(addNotificationToApp("Document Failed to Fetch ", "danger"));
        }
    };
}

export function fetchGetDocumentBlobForGroup(groupId, documentId) {
    return async (dispatch) => {
        dispatch(DocumentsActionService.requestDocument());
        try {
            const json = await fetchBrary.get(`${ROOT_URL}/api/groups/${groupId}/documents/${documentId}`);
            dispatch(DocumentsActionService.requestDocumentSuccess(json));
            const stream = Base64ToArrayBuffer(json.blob);
            const fileName = json.name;
            SaveByteArray(fileName, stream);
        }
        catch (err) {
            dispatch(DocumentsActionService.requestDocumentFailure(err));
            dispatch(addNotificationToApp("Document Failed to Fetch ", "danger"));
        }
    };
}

export function fetchGetDocumentBlobForGroupAsBlob(groupId, documentId) {
    return async (dispatch) => {
        dispatch(DocumentsActionService.requestDocument());
        try {
            const json = await fetchBrary.get(`${ROOT_URL}/api/groups/${groupId}/documents/${documentId}`);
            dispatch(DocumentsActionService.requestDocumentSuccess(json));
            const stream = Base64ToArrayBuffer(json.blob);
            return new Blob([stream]);
        }
        catch (err) {
            dispatch(DocumentsActionService.requestDocumentFailure(err));
            dispatch(addNotificationToApp("Document Failed to Fetch ", "danger"));
        }
    };
}